import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09633eca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-control" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "auto" }
const _hoisted_7 = { class: "input-tooltip" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltip" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext" }, [
    /*#__PURE__*/_createTextVNode("Beispiel: Das Schreiben ist an die Firma Muster GmbH gerichtet, mit Firmensitz bei der Firma Mustermann AG. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Muster GmbH "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" c/o Mustermann AG "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Musterstraße 17 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 12345 Musterstadt")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "material-icons material-symbols-outlined",
    style: {"color":"gray"}
  }, " info ")
], -1))
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "input" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "auto" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "auto" }
const _hoisted_15 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_base_autocomplete = _resolveComponent("base-autocomplete")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_selector_country = _resolveComponent("selector-country")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.company.isValid || !_ctx.co.isValid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Unternehmensdaten überprüfen"))
        : (
        !_ctx.land.isValid ||
        !_ctx.plz.isValid ||
        !_ctx.city.isValid ||
        !_ctx.street.isValid ||
        !_ctx.nr.isValid
      )
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Adressdaten überprüfen "))
          : (!_ctx.formIsValid)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Adresse wurde nicht gefunden"))
            : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_base_label, { title: 'Unternehmen*' }),
      _createVNode(_component_base_label, {
        margin: '290px',
        title: 'c/o*'
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_base_autocomplete, {
        items: _ctx.autocompleteCompanyData,
        modelValue: _ctx.company.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company.value) = $event)),
        valid: _ctx.company.isValid,
        onBlur: _ctx.validateCompany,
        onKeyUp: _ctx.autocompleteCompany,
        dropdown: true,
        onUpdateModel: _ctx.updateModel,
        width: '300px'
      }, null, 8, ["items", "modelValue", "valid", "onBlur", "onKeyUp", "onUpdateModel"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_base_input, {
          modelValue: _ctx.co.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.co.value) = $event)),
          valid: _ctx.co.isValid,
          width: '300px',
          onBlur: _ctx.validateCo
        }, null, 8, ["modelValue", "valid", "onBlur"]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_base_label, { title: 'Land*' })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_selector_country, {
        modelValue: _ctx.land.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.land.value) = $event)),
        valid: _ctx.land.isValid,
        onUpdateModel: _ctx.updateCode,
        onBlur: _ctx.validateLand
      }, null, 8, ["modelValue", "valid", "onUpdateModel", "onBlur"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_base_label, { title: 'PLZ*' }),
      _createVNode(_component_base_label, {
        margin: '345px',
        title: 'Stadt*'
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_base_autocomplete, {
        items: _ctx.autocompletePlzData,
        modelValue: _ctx.plz.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.plz.value) = $event)),
        valid: _ctx.plz.isValid,
        onBlur: _ctx.validatePlz,
        onKeyUp: _ctx.autocompletePlz,
        auto: 'plz',
        "max-length": '10',
        dropdown: true,
        onUpdateModel: _ctx.updateModel,
        width: '300px'
      }, null, 8, ["items", "modelValue", "valid", "onBlur", "onKeyUp", "onUpdateModel"]),
      _createVNode(_component_base_autocomplete, {
        items: _ctx.autocompleteCityData,
        modelValue: _ctx.city.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.city.value) = $event)),
        valid: _ctx.city.isValid,
        onBlur: _ctx.validateCity,
        onKeyUp: _ctx.autocompleteCity,
        auto: 'city',
        dropdown: true,
        onUpdateModel: _ctx.updateModel,
        width: '300px'
      }, null, 8, ["items", "modelValue", "valid", "onBlur", "onKeyUp", "onUpdateModel"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_base_label, { title: 'Straße*' }),
      _createVNode(_component_base_label, {
        margin: '330px',
        title: 'Nr*'
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_base_autocomplete, {
        items: _ctx.autocompleteStreetData,
        modelValue: _ctx.street.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.street.value) = $event)),
        valid: _ctx.street.isValid,
        dropdown: true,
        onBlur: _ctx.validateStreet,
        onKeyUp: _ctx.autocompleteStreet,
        width: '300px'
      }, null, 8, ["items", "modelValue", "valid", "onBlur", "onKeyUp"]),
      _createVNode(_component_base_autocomplete, {
        items: _ctx.autocompleteNrData,
        modelValue: _ctx.nr.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nr.value) = $event)),
        valid: _ctx.nr.isValid,
        dropdown: false,
        onBlur: _ctx.validateNr,
        onKeyUp: _ctx.autocompleteNr,
        width: '40px'
      }, null, 8, ["items", "modelValue", "valid", "onBlur", "onKeyUp"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_base_button, {
        title: 'Zurück',
        onClick: _ctx.backToUser
      }, null, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        title: 'Weiter',
        onClick: _ctx.submitCompany
      }, null, 8, ["onClick"])
    ])
  ], 64))
}